import React from 'react';
import { translate } from 'react-i18next';

import SidebarDropOfferItem from 'components/ScheduleSidebar/SidebarDropOfferItem.js';

class SidebarExchangesAndDrops extends React.Component {
  constructor(props) {
    super(props);

    this.selectedShiftID = null;
    this.selectedReplyShiftID = null;

    this.onAvailabilitiesDetailClick = this.onAvailabilitiesDetailClick.bind(this);

    this.state = {
      selectedDepartmentID: null,
      selectedPosition: null,
      exchanged: false,
    };
  }

  componentDidMount() {
    BidsStore.on(
      'exchanges:post:bids:success',
      function (collection, response) {
        this.setState({ exchanged: true });
      },
      this,
    );

    BidsStore.on(
      'exchanges:post:bid:drop:success',
      function (collection, response) {
        this.setState({ exchanged: true });
      },
      this,
    );
  }

  componentWillUnmount() {
    this.selectedShiftID = null;
    this.selectedReplyShiftID = null;
    BidsStore.off(null, null, this);
  }

  onAvailabilitiesDetailClick(shift) {
    const that = this;

    let type = shift.drop ? 'drop' : 'exchange';
    const exchangeUser = ExchangesStore.getExchangeUser(shift.user_id);
    if (type === 'exchange') {
      const me = Utils.getCoreUser();
      if (exchangeUser.id === me.id) {
        type = 'my exchange';
      }
    }
    if (type === 'exchange' && BidsStore.iHazBidz(shift)) {
      that.props.toggleOpenSidebar(type, shift, true);
    } else {
      that.props.toggleOpenSidebar(type, shift);
    }
  }

  _checkForExchangeOverlap(exchange, shifts) {
    if (_.isEmpty(shifts) || exchange.drop) {
      return true;
    }
    const len = shifts.length;
    let valid = true;
    let count = 0;
    if (len > 1 && !exchange.drop) {
      for (let i = 0; i < len; i++) {
        const shift = shifts[i];
        const selectedShiftStart = moment(shift.start_time).tz(shift.time_zone);
        const selectedShiftEnd = moment(shift.end_time).tz(shift.time_zone);
        const exchangerStart = moment(exchange.shift_details.start_time).tz(
          exchange.shift_details.time_zone,
        );
        const exchangerEnd = moment(exchange.shift_details.end_time).tz(
          exchange.shift_details.time_zone,
        );
        const isBetween = moment(selectedShiftStart).isBetween(exchangerStart, exchangerEnd)
          || moment(selectedShiftEnd).isBetween(exchangerStart, exchangerEnd)
          || (moment(selectedShiftStart).isSame(exchangerStart)
            && moment(selectedShiftEnd).isSame(exchangerEnd));

        if (isBetween) {
          count++;
          // valid = false;
          // break;
        }
      }
    }
    if (count > 1) {
      valid = false;
    }
    return valid;
  }

  render() {
    const len = this.props.shiftData ? this.props.shiftData.length : 0;
    const offers = [];
    if (len > 0) {
      for (let i = 0; i < len; i++) {
        const startTime = moment(this.props.shiftData[i].shift_details.start_time)
          .tz(this.props.shiftData[i].shift_details.time_zone)
          .format('h:mm a');
        const endTime = moment(this.props.shiftData[i].shift_details.end_time)
          .tz(this.props.shiftData[i].shift_details.time_zone)
          .format('h:mm a');
        const hideEnd = this.props.shiftData[i].shift_details.hide_end_time;
        let detailLabel = this.props.t('SidebarExchangesAndDrops.exchange_details');
        if (this.props.shiftData[i].drop) {
          detailLabel = this.props.t('SidebarExchangesAndDrops.drop_details');
        }

        if (this.props.shiftData[i].state == 'accepted') {
          detailLabel = this.props.t('SidebarExchangesAndDrops.pending_approval');
        }

        if (this._checkForExchangeOverlap(this.props.shiftData[i], this.props.dayShiftData)) {
          offers.push(
            <SidebarDropOfferItem
              key={this.props.shiftData[i].id}
              indexIwishICouldRefactorOut={i}
              shift={this.props.shiftData[i]}
              startTime={startTime}
              endTime={endTime}
              hideEnd={hideEnd}
              label={detailLabel}
              deeplinked={this.props.deeplinked}
              clickDelegate={this.onAvailabilitiesDetailClick.bind(this)}
            />,
          );
        }
      }
    }

    const classes = `calendar-input exchanged-shifts ${
      !this.props.active || offers.length == 0 ? 'hide' : ''
    }`;

    return (
      <div className={classes}>
        <span className="calendar-input-bullet exchange">{this.props.t('SidebarExchangesAndDrops.exchanges_and_drops')}</span>
        <div className="data-list shifts">
          <ul>{offers}</ul>
        </div>
      </div>
    );
  }
}

export default translate()(SidebarExchangesAndDrops);
